export default `<?xml version="1.0" encoding="UTF-8"?>
<svg viewBox="0 0 66 66" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" role="img">
<title>Doublefin logo</title>
<g clip-path="url(#clip0_3264_1095)">
<path d="M32.6 0C41.246 0 49.538 3.43465 55.6517 9.54834C61.7654 15.662 65.2 23.954 65.2 32.6C65.2 41.2461 61.7654 49.538 55.6517 55.6517C49.538 61.7654 41.246 65.2 32.6 65.2L48.9 32.6L32.6 0Z" fill="#00C5E5"/>
<path d="M0 0H16.3H32.6L16.3 32.6L0 0Z" fill="#00C5E5"/>
<path d="M32.6 65.1901H16.3H0L16.3 32.6001L32.6 65.1901Z" fill="#00C5E5"/>
</g>
<defs>
<clipPath id="clip0_3264_1095">
<rect width="65.19" height="65.19" fill="white"/>
</clipPath>
</defs>
</svg>
`;